<template>
  <div
    v-if="usedArr( splitLists )"
    class="w-full mb-7 last:mb-0 flex justify-center"
  >
    <ol
      v-for="(list, i1) in splitLists"
      :key="`sa-list-${i1+1}`"
      :class="[
        `sa-list-${i1+1} w-1/${splitLists.length}`,
        listClasses
      ]"
    >
      <li
        v-for="item in list"
        :key="item.slug"
        class="mb-0_5 last:mb-0"
      >
        <router-link
          :class="linkClasses"
          :to="item.routeTo"
          :title="htmlDecode(item.title)"
          v-html="item.title"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'SubjectAreaLists',

  props: {
    list: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    // Data
    ...mapState([ 'windowDimensions' ]),
    ...mapGetters([ 'myStore' ]),
    listStyles() { return this.myStore(['styles', 'subject_areas', 'list']) ?? {} },
    linkStyles() { return this.listStyles.link_styles ?? {} },
    focusLinkStyles() { return this.linkStyles.focus ?? {} },
    hoverLinkStyles() { return this.linkStyles.hover ?? {} },
    // Classes
    listClasses() {
      const { listStyles } = this
      return [
        'md:max-w-80',
        'mr-0_5',
        'last:mr-0',
        'py-4',
        `bg-${listStyles.bg_color ?? 'white'}`,
        'text-left'
      ]
    },
    linkClasses() {
      // Data
      const { linkStyles, focusLinkStyles, hoverLinkStyles } = this
      // Return
      return [
        // Padding
        'px-7 py-1_5',
        // Display
        'block',
        // BG
        `bg-${linkStyles.bg_color ?? 'transparent'}`,
        `focus:bg-${focusLinkStyles.bg_color ?? 'black'} lg:hover:bg-${hoverLinkStyles.bg_color ?? 'accent-1'}`,
        // Colours
        `text-${linkStyles.text_color ?? 'body'}`,
        `focus:text-${focusLinkStyles.text_color ?? 'white'} lg:hover:text-${hoverLinkStyles.text_color ?? 'white'}`,
        // Font Family
        `font-${linkStyles.font_family ?? 'body'}`,
        // Font Weight
        `font-${linkStyles.font_family ?? 'body'}-${linkStyles.font_weight ?? 'body'}`,
        // Text Transform
        linkStyles.text_transform ?? 'normal-case',
        // Interaction
        'transition-colors duration-500 ease-in-out',
        'focus:outline-none'
      ]
    },
    // Splits the list of subject areas into columns
    initColumnCount() {
      const arr = this.list
      const length = arr.length
      const winDimWidth = this.windowDimensions.width
      const isGteXl = winDimWidth >= 1367
      const isGteLg = winDimWidth >= 1024
      const isGteSm = winDimWidth >= 620
      const is4Col = length > 30 && isGteXl
      const is3Col = length > 20 && isGteLg
      const is2Col = length > 12 && isGteSm
      return is4Col ? 4 : is3Col ? 3 : is2Col ? 2 : 1
    },
    splitLists() {
      const clonedListProp = this.list.slice()
      const length = clonedListProp.length
      const initColumnCount = this.initColumnCount
      let columnCount = initColumnCount
      let i1 = 0
      const out = []
      while (i1 < length) {
        const size = Math.ceil((length - i1) / columnCount--)
        out.push(clonedListProp.slice(i1, i1 += size))
      }
      return out
    }
  }
}
</script>

